export const setDistributorInfo=(data)=>{
    return {
        type: "SET_DISTRIBUTOR_INFO",
        info: data,
    }
}
export const nullDistributorInfo=()=>{
    return{
        type:"NULL_DISTRIBUTOR_INFO",
        info: null
    }
}
export const getDistributorInfo=()=>{
    return {
        type: "GET_DISTRIBUTOR_INFO",
        
    }
}
